// src/features/suppliers/pages/SuppliersPage.js
import React from 'react';
import MasterDataListPage from '../../master-data/pages/MasterDataListPage';

const LocationsPage = () => {
  return <MasterDataListPage type="locations" />;
};

export default LocationsPage;